import React from 'react';
import PropTypes from 'prop-types';
import theme from 'styled-theming';
import styled from 'styled-components';
import { Box } from 'rebass/styled-components';

const backgroundColor = theme('mode', {
  light: (props) => props.theme.colors.greyLight,
  dark: (props) => props.theme.colors.lpGhost,
});

const containerBackgroundColor = theme('mode', {
  light: (props) => props.theme.colors.whiteGrey,
  dark: (props) => props.theme.colors.greyDarker,
});

const color = theme('mode', {
  light: (props) => props.theme.colors.deepGrey,
  dark: (props) => props.theme.colors.white,
});

const DropdownContainer = styled(Box)`
  z-index: 2;
  position: absolute;
  top: 40px;
  background-color: ${containerBackgroundColor};
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.15), 0px 1px 4px rgba(0, 0, 0, 0.17);
  color: ${color};
`;

const DropdownItem = styled(Box)`
  &:hover {
    background-color: ${backgroundColor};
    cursor: pointer;
  }
`;

const DropDownCard = ({ data = [], setOpen }) => (
  <DropdownContainer>
    {data.map((item, i) => (
      <DropdownItem
        key={i}
        onClick={() => setOpen(false)}
      >
        {item}
      </DropdownItem>
    ))}
  </DropdownContainer>
);

DropDownCard.defaultProps = {
  data: [],
  setOpen: () => { },
};

DropDownCard.propTypes = {
  data: PropTypes.array,
  setOpen: PropTypes.func,
};

export default DropDownCard;
